<template>
    <div class="bot-form-rt">

        <el-dialog
                custom-class="dellDiaLogClass"
                :append-to-body="true"
                @close="dialogVisible = false"
                :visible.sync="dialogVisible"
                width="30%">
            <template>
                <!-- 市价交易 -->
                <span>确认撤销委托</span>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleClose()">确 定</el-button>
            </span>
        </el-dialog>

        <div class="form-rt-head">
            <div class="form-rt-nav" :class="{'active': index === nowTag}"
                 v-for="(tag, index) in tags" :key="tag"
                 @click="setNowTag2(index)"
            >{{tag}}
            </div>
            <div class="form-shua" @click="refesh()">刷新</div>
        </div>
        <div class="form-rt-body"
             v-loading="loading"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
             v-if="headers[nowTag].length">
            <div class="form-rt-subhead"
                 :style="{'min-width': getMiniWidth() + 'px'}">
                <div class="subhead-nav"
                     :class="{'w': tag.length === 3}"
                     v-for="tag in headers[nowTag]" :key="tag[1]">{{tag[0]}}
                </div>
            </div>
            <template v-if="nowTag === 0">
                <div class="form-rt-neir" :style="{'min-width': getMiniWidth() + 'px'}"
                     v-for="item in datas" :key="item.id">
                    <div class="neir-nav"
                         @click="setNowFoucsDetail(item.stock_code)"
                         :class="getColors(tag[1], item, tag.length)"
                         v-for="tag in headers[nowTag]" :key="tag[1]">
                        {{$globle.itemValue(item[tag[1]], tag[1])}}
                    </div>
                </div>
            </template>
            <template v-if="nowTag === 1">
                <div class="form-rt-neir" :style="{'min-width': getMiniWidth() + 'px'}"
                     v-for="item in datas" :key="item.id">
                    <div class="neir-nav"
                         :class="{'w': tag.length === 3}"
                         @click="setNowFoucsDetail(item.stock_code)"
                         v-for="tag in headers[nowTag]" :key="tag[1]">
                        <template v-if="tag[1] === 'sell_time'">
                            {{new Date(+item.sell_time * 1000).format('yyyy-MM-dd hh:mm:ss')}}
                        </template>
                        <template v-else-if="tag[1] === 'cancel_ctrl'">
                            <template v-if="item.msg ==='已撤单' || item.msg ==='撤单中'">
                                {{item.msg}}
                            </template>
                            <template v-else>
                                <button @click="cancelorder(item.cancel_type, item.id)">撤单</button>
                            </template>
                        </template>
                        <template v-else>
                            {{$globle.itemValue(item[tag[1]], tag[1])}}
                        </template>
                    </div>
                </div>
            </template>
            <template v-if="nowTag === 2">
                <div class="form-rt-neir" :style="{'min-width': getMiniWidth() + 'px'}"
                     v-for="item in datas" :key="item.id">
                    <div class="neir-nav"
                         @click="setNowFoucsDetail(item.stock_code)"
                         :class="{'w': tag.length === 3,
                     'red': tag[1] === 'strategy_type' && +item[tag[1]] === 1,
                     'green': tag[1] === 'strategy_type' && +item[tag[1]] === 2}"
                         v-for="tag in headers[nowTag]" :key="tag[1]">
                        {{$globle.itemValue(item[tag[1]], tag[1])}}
                    </div>
                </div>
            </template>
            <template v-if="nowTag === 3 && account_info">
                <div class="form-rt-neir" :style="{'min-width': getMiniWidth() + 'px'}">
                    <div class="neir-nav"
                         :class="getColors(tag[1], account_info, tag.length)"
                         v-for="tag in headers[nowTag]" :key="tag[1]">
                        <template v-if="tag[1] === 'accont'">
                            {{trade_account}}
                        </template>
                        <template v-else>
                            {{account_info[tag[1]]}}
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseFooterPositions",
        data: function () {
            return {
                tags: Object.freeze(['持仓', '委托', '成交', '资金']),
                nowTag: 0,
                loading: true,
                datas: null,
                headers: Object.freeze([
                    this.$globle.strategyTag, this.$globle.chedanstrategyTag, this.$globle.historyTag, this.$globle.accountinfoTag
                ]),
                intrvalHand: null,
                dialogVisible: false,
                temp: []
            }
        },
        created() {
            this.getNewData(this.nowTag);
        },
        computed: {
            token: function () {
                return this.$store.state.now_token;
            },
            trade_account: function () {
                return this.$store.state.now_trade_account;
            },
            account_info: function () {
                return this.$store.state.account_info;
            },
            isopen() {
                return this.$store.state.isopen;
            }
        },
        watch: {
            account_info: function () {
                this.loading = false;
            },
            nowTag: function (v) {
                this.datas = [];
                this.loading = true;
                // 标签切换，他要变
                this.getNewData(v);
            },
            trade_account: function (v) {
                // 相互改变，他要变
                this.getNewData(this.nowTag);
            },
            // 底部的任何操作，都需要右侧列表做出更新的动作
            '$store.state.right_info': function () {
                setTimeout(() => {
                    this.getNewData(this.nowTag);
                }, 6000)
            },
            isopen(v) {
                if(v) {
                    // 行情启动，他要变
                    this.getNewData(this.nowTag);
                }
            }
        },
        methods: {
            cancelorder(cancel_type, id) {
                if (cancel_type) {
                    if (!this.dialogVisible) {
                        this.temp = [cancel_type, id];
                        this.dialogVisible = true;
                        return false;
                    }
                    if (this.dialogVisible) {
                        this.temp = null;
                        this.$api.cancelorder(this.token, this.trade_account, cancel_type, id).then(res => {
                            this.dialogVisible = false;
                            this.$message({
                                message: res.data.code === 200 ? '撤单成功' : res.data.msg,
                                type: res.data.code === 200 ? 'success' : 'error'
                            });
                            this.$store.commit('UPDATE_ACCOUNT_INFO');
                            this.$store.commit('UPDATE_RIGHT_INFO');
                            this.chedanstrategy();
                        })
                    }
                }
            },
            setNowTag2(tag) {
                this.nowTag = tag;
            },
            // 查看委托
            chedanstrategy() {
                this.$api.chedanstrategy(this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.datas = res.data.data;
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            checkstrategyhistory() {
                this.$api.checkstrategyhistory(this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.datas = res.data.data;
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            // 查看持仓中的策略
            getCheckstrategy() {
                this.$api.checkstrategy(this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.datas = Object.freeze(res.data.data);
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            getNewData(v) {
                if (this.intrvalHand) {
                    clearInterval(this.intrvalHand)
                }
                switch (v) {
                    case 0:
                        this.getCheckstrategy();
                        break;
                    case 1:
                        this.chedanstrategy();
                        break;
                    case 2:
                        this.checkstrategyhistory();
                        break;
                    case 3:
                        this.$store.commit('UPDATE_ACCOUNT_INFO');
                        break;
                }
                if(this.isopen) {
                    this.intrvalHand = setTimeout(() => {
                        this.getNewData(v);
                    }, 6000)
                }
            },
            refesh() {
                this.loading = true;
                this.getNewData(this.nowTag);
            },
            setNowFoucsDetail(code) {
                this.$store.commit('SET_FOUCS_GP', code);
                this.$store.commit('SCROLL_TO_ITEM');
            },
            getColors(tag, item, len) {
                if (tag === 'profit_ratio') {
                    return {
                        'w': len === 3,
                        'red': +item.profit_ratio > 0,
                        'green': +item.profit_ratio < 0
                    }
                }
                if (tag === 'getprice') {
                    return {
                        'w': len === 3,
                        'red': +(item.getprice.replace(',', '')) > 0,
                        'green': +(item.getprice.replace(',', '')) < 0
                    }
                }
                if (tag === 'nowyingkui') {
                    return {
                        'w': len === 3,
                        'red': +this.account_info.nowyingkui.replace(',', '') > 0,
                        'green': +this.account_info.nowyingkui.replace(',', '') < 0
                    }
                }
                if (tag === 'zongyingkui') {
                    return {
                        'w': len === 3,
                        'red': +this.account_info.zongyingkui.replace(',', '') > 0,
                        'green': +this.account_info.zongyingkui.replace(',', '') < 0
                    }
                }
                return {
                    'w': len === 3
                }
            },
            // 自动计算表格的宽度
            getMiniWidth() {
                let wCount = 0;
                this.headers[this.nowTag].map(v => {
                    if (v.length === 3) {
                        wCount++;
                    }
                });
                return 119 * this.headers[this.nowTag].length + 82 * wCount
            },
            handleClose() {
                this.cancelorder(this.temp[0], this.temp[1])
            }
        }
    }
</script>

<style scoped>

    .form-rt-subhead,
    .form-rt-neir {
        white-space: nowrap;
        top: 0;
        min-width: 1044px;
    }
</style>
